import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui'
import { createFileRoute } from '@tanstack/react-router'
import { CircleAlert } from 'lucide-react'
import { z } from 'zod'

export const Route = createFileRoute('/connector-error')({
  validateSearch: z.object({
    error: z.string().optional().catch('')
  }),
  head: () => ({ meta: [{ title: 'Connector Error - Snowvault' }] }),
  component: ConnectorError
})

function ConnectorError() {
  const { error } = Route.useSearch()

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-md">
        <Card>
          <CardHeader className="items-center text-center">
            <CircleAlert className="mb-2 h-12 w-12 text-destructive" />
            <CardTitle>Connector Setup Failed</CardTitle>
            <CardDescription>
              {error || 'An error occurred during the connector authorisation process.'}
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center">
            <Button asChild>
              <a href="/">Return to Snowvault</a>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
